// Educational testimonial with your preferred layout + the 3 requested elements
import { StarIcon } from '@heroicons/react/20/solid'

export default function EducationalTestimonial() {
    return (
      <div className="bg-gradient-to-r from-indigo-50 to-purple-50 py-10 sm:py-12">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl text-center mb-6">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-3xl">
              Real Results in Real Classrooms
            </h2>
            <p className="mt-3 text-base text-gray-600">
              See how educators are transforming their teaching with MyTaleMaker
            </p>
          </div>
  
          <div className="mx-auto max-w-4xl">
            <div className="relative bg-white rounded-2xl shadow-xl p-6 lg:p-8">
              {/* Quote icon */}
              <div className="absolute top-6 left-6">
                <svg className="h-8 w-8 text-indigo-200" fill="currentColor" viewBox="0 0 32 32">
                  <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                </svg>
              </div>
  
              {/* Testimonial content */}
              <div className="pt-4">
                <blockquote className="text-base leading-7 text-gray-700 lg:text-lg lg:leading-8">
                  "We've had a wonderful experience using MyTaleMaker.com as part of our NGO's English learning program for underprivileged children in India. The AI-powered platform creates beautiful, personalized stories based on prompts and each child's unique character traits. The stories are not only meaningful and engaging, but also{' '}
                  <span className="font-semibold text-indigo-600">visually rich and culturally relevant</span>.
                  <br /><br />
                  Bhumika, the creator, has been incredibly supportive throughout the process—going above and beyond by creating custom illustrations that reflect our students' cultural ethnicity authentically, such as their school uniforms.{' '}
                  <span className="font-semibold text-indigo-600">The children absolutely loved the story we created together and are excited for more!</span>
                  <br /><br />
                  We're now working on additional stories that continue to reflect each child's personality. This has been a truly inspiring and joyful tool for both teaching and connection. Highly recommended!"
                </blockquote>
  
                {/* Attribution */}
                <div className="mt-6 flex items-center">
                  <div className="flex-shrink-0">
                    <div className="h-12 w-12 rounded-full bg-indigo-100 flex items-center justify-center">
                      <span className="text-indigo-600 font-semibold text-lg">NGO</span>
                    </div>
                  </div>
                  <div className="ml-4">
                    <div className="text-base font-semibold text-gray-900">
                      Madhvi P
                    </div>
                    <div className="text-sm text-gray-500">
                      WeEducate Foundation
                    </div>
                  </div>
                  <div className="ml-auto flex">
                    {[...Array(5)].map((_, i) => (
                      <StarIcon key={i} className="h-5 w-5 text-yellow-400" />
                    ))}
                  </div>
                </div>
              </div>
  
              {/* Featured Success Story badge */}
              <div className="absolute top-6 right-6">
                <span className="inline-flex items-center rounded-full bg-green-100 px-3 py-1 text-sm font-medium text-green-800">
                  ⭐ Featured Success Story
                </span>
              </div>
            </div>
  
            {/* Call-to-action for educators */}
            <div className="mt-6 text-center">
              <p className="text-sm text-gray-600 mb-3">
                Are you an educator interested in using MyTaleMaker for your students?
              </p>
              <a 
                href="mailto:contact@mytalemaker.com?subject=Educational%20Program%20Inquiry"
                className="inline-flex items-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 transition-colors"
              >
                Contact Us for Educational Programs
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }